/* eslint-disable no-unused-vars -- keep imports for future use */
import React, { useEffect, useRef, lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, CircularProgress, Typography } from '@mui/material';
import data from '../components/servicesdata';
import dataproduct from '../components/producthomedata';
import dataintro from '../components/introdata';
import {Navbar} from '../components/navbar';
import LCPPreload from '../components/LCPPreload';
import AnnouncementPopup from '../components/AnnouncementPopup';

// Lazy load heavy components
const Footer = lazy(() => import('../components/footer'));
const Intro = lazy(() => import('../components/intro'));

// Lazy load below-the-fold components for better initial load performance
const DirectionStack = lazy(() => import('../components/statistics'));
const GridComponent = lazy(() => import('../components/Services'));
const SliderprojectComponent = lazy(() => import('../components/projects'));

// Loading fallback for lazy components
const ComponentLoader = () => (
  <Box 
    sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '300px',
      py: 4
    }}
  >
    <CircularProgress size={40} />
  </Box>
);
const Landingpage = () => {
  const sliderRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#slider') {
      sliderRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);
  return (
    <>
      <LCPPreload />
      <Helmet>
        <title>Advance Resources – IT & Communication Solutions Pakistan | VoIP, Network & SEO Services</title>
        <link rel="canonical" href="https://ar.com.pk/" />
        <meta name="description" content="Leading IT & communication solutions in Lahore & Pakistan. We specialize in VoIP PBX, Yeastar & Yealink products, network infrastructure, web development, digital marketing & SEO services. Get expert support now." />
        <meta name='keywords' content="advance resources, yeastar distributor, yealink distributor, voip, pbx, ip phones price, pbx price, video conferencing, network infrastructure, it services, lahore, karachi, islamabad, pakistan" />
      </Helmet>
      {/* Announcement Popup - Shows until January 19, 2026 */}
      <AnnouncementPopup 
        imageSrc="/images/announcement/announcement.svg" 
        imageAlt="Special Announcement"
      />
    <div>
       <Navbar variant='absolute' sectionId="section1" label="Go to Section 1"/> 
       <Suspense fallback={<ComponentLoader />}>
         <Intro data={dataintro}/>
       </Suspense>
       
       {/* Lazy loaded below-the-fold components */}
       <Suspense fallback={<ComponentLoader />}>
         <DirectionStack />
       </Suspense>
       
       <Suspense fallback={<ComponentLoader />}>
         <GridComponent data={data} />
       </Suspense>
       
       <div id="slider">
         <Suspense fallback={<ComponentLoader />}>
           <SliderprojectComponent data={dataproduct} />
         </Suspense>
       </div>
   
       <Suspense fallback={null}>
         <Footer sectionId="section1" label="Go to Section 1" /> 
       </Suspense>
    </div>
    </>
  )
}

export default Landingpage
